import React from "react";
import { Badge, Box, type SxProps, type Theme } from "@mui/material";
import Badgeicon from "./BadgeIcon";

export default function IconContained({
  type,
  icon,
  sx,
}: {
  type?: string;
  icon: React.JSX.Element;
  sx?: SxProps<Theme>;
}) {
  return (
    <Badge
      badgeContent={<Badgeicon type={type} />}
      classes={{ badge: "icon-badge" }}
      sx={{ "& .MuiBadge-badge": { fontSize: 16 } }}
    >
      <Box className={"icon-container"} sx={sx}>
        {icon}
      </Box>
    </Badge>
  );
}
